module.exports = __webpack_public_path__ + "static/media/9DESA2.6681f28d.jpg";